




































































import Vue from 'vue'
import { submitQuestionFeedback } from '@/api/question'
import { isMobile } from '@/lib/helpers/index.ts'
import { scrollTop } from '@/lib/functions'
import Page from './page.vue'
import VButton from '@/components/button/basic-button.vue'
import ProgressLinear from '@/components/progress-linear/progress-linear.vue'
import FeedbackDialog from '@/components/dialog/feedback-dialog/index.vue'
import ConfirmDialog from '@/components/dialog/confirm-dialog/index.vue'
import SwipeNavButton from '@/components/swipe-nav-button/swipe-nav-button.vue'

interface Data {
  isMobile: boolean
  showFeedback: boolean
  showConfirmFeedback: boolean
  selectedQuestion: number | null
  elm: Element
  showSecondSwipeBtn: boolean
}

export default Vue.extend({
  name: 'ImplView',

  props: {
    unit: {
      type: Object as Prop<api.unit.GetUnitResponseData>,
      required: true
    },
    impl: {
      type: Object as Prop<api.unitImpl.UnitImpl>,
      required: true
    },
    seq: {
      type: Number as Prop<number>,
      required: true
    },
    currentQuestion: {
      type: Object as Prop<api.unitImpl.Question>,
      required: true
    },
    backFromConfirm: {
      type: Boolean as Prop<boolean>,
      default: false
    },
    confirmBeforeLeave: {
      type: Boolean as Prop<boolean>,
      default: true
    }
  },

  components: {
    VButton,
    ProgressLinear,
    Page,
    FeedbackDialog,
    ConfirmDialog,
    SwipeNavButton
  },

  data(): Data {
    return {
      isMobile: isMobile(),
      showFeedback: false,
      showConfirmFeedback: false,
      selectedQuestion: null,
      elm: document.getElementsByClassName('back-button')[0],
      showSecondSwipeBtn: false
    }
  },

  beforeMount() {
    window.addEventListener('beforeunload', this.unload)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.unload)
    // @ts-ignore
    this.elm?.style.setProperty('display', '', 'important')
  },

  mounted() {
    scrollTop()
    this.$emit('start')

    // @ts-ignore
    this.elm?.style.setProperty('display', 'none', 'important')
  },

  computed: {
    isNormalExam(): boolean {
      return (
        this.unit.unit_type === 'exam' &&
        this.impl.impl_question_type === 'normal'
      )
    },

    timeLimit(): number {
      return this.unit.time_limit
    },

    progress(): number {
      return (100 / this.impl.questions.length) * this.seq
    },

    swiperOption(): any {
      return {
        swipeHandler: 'empty',
        spaceBetween: 0,
        initialSlide: this.seq - 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  methods: {
    handleClickConfirm() {
      this.$emit('confirm', this.impl.questions)
    },

    // 左右のスライドボタンをクリック
    clickSlideButton(direction: 'next' | 'prev') {
      this.$emit('update-answers')

      const newSeq = direction === 'next' ? this.seq + 1 : this.seq - 1
      this.$emit('update-seq', newSeq)

      window.scrollTo(0, 0)
    },

    handleUpdateBookmark(question: api.unitImpl.Question) {
      this.$emit('update-bookmark', question)
    },

    handleFeedback(v: number) {
      this.showFeedback = true
      this.selectedQuestion = v
    },

    handleSubmitFeedback(v: any) {
      if (this.selectedQuestion) {
        submitQuestionFeedback(this.selectedQuestion, v)
        this.showConfirmFeedback = true
      }
    },

    unload($event: any) {
      // ページを離れる際にメッセージを表示する
      if (this.confirmBeforeLeave) {
        $event.returnValue = '\o/'
      }
    },

    updateShowSecondSwipeBtn(show: boolean) {
      this.showSecondSwipeBtn = show
    }
  }
})
